const Style = {
  auth: "bg-[#F2F2F3] min-h-screen lg:flex lg:justify-between",
};

export default Style;
